import { jsx } from "react/jsx-runtime";
import { Box, Loader } from "braid-design-system";
import Img from "react-image";
import { StrategiesEnum } from "@seek/image-service-types";
import compact from "lodash/compact.js";
import { getAssetSrcs } from "../../BrandLogo/Logo/Logo.mjs";
import { image, imageContainer } from "../CoverImage.css.mjs";
const getCoverSrcs = (cover, showThumbnail) => {
  var _a;
  return compact([
    showThumbnail && ((_a = cover == null ? void 0 : cover.strategies) == null ? void 0 : _a[StrategiesEnum.JDP_COVER_THUMBNAIL]),
    ...getAssetSrcs({ asset: cover, strategyName: StrategiesEnum.JDP_COVER })
  ]);
};
const Cover = ({
  asset,
  directUrl,
  showThumbnail = false,
  showLoading = false
}) => {
  const coverSrcs = getCoverSrcs(asset, showThumbnail);
  const src = directUrl || coverSrcs;
  return showLoading ? /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      className: image,
      children: /* @__PURE__ */ jsx(Loader, {})
    }
  ) : /* @__PURE__ */ jsx("div", { "data-testid": "bx-cover-image", className: imageContainer, children: /* @__PURE__ */ jsx(Img, { src, alt: "", className: image }) });
};
export {
  Cover
};
